import NavLink from '../shared/buttons/nav-link';
import { PaymentType } from '../../api/payment';
import Segment from '../shared/segment';

export type PaymentVerifyPropsType = {
  payment: PaymentType;
};

function PaymentVerify({ payment }: PaymentVerifyPropsType) {
  const paymentCode = payment.result.result;
  return (
    <Segment color='green' textAlign='center' className='text-xl'>
      {payment.status && [100, 201].includes(paymentCode) ? (
        paymentCode === 100 ? (
          <>
            <p>بسته‌های موردنظر شما با موفقیت خریداری گردید.</p>
            <p className='my-2'>
              <span>شماره تراکنش خرید: </span>
              <span>{payment.result.refNumber}</span>
            </p>
          </>
        ) : (
          <p>تراکنش با موفقیت انجام شده است.</p>
        )
      ) : (
        <p>متاسفانه تراکنش ناموفق بود.</p>
      )}
      <NavLink to='/exams' color='green' content='بازگشت' className='mx-auto my-6' />
    </Segment>
  );
}

export default PaymentVerify;
